export default __webpack_public_path__ + "static/media/female.aae9e532.svg";